var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.719 16.809c.351.351.351.878 0 1.195-.14.176-.352.246-.563.246a.847.847 0 01-.633-.246l-4.71-4.711a7.187 7.187 0 01-4.536 1.582C3.27 14.875 0 11.605 0 7.562 0 3.556 3.234.25 7.277.25c4.008 0 7.313 3.305 7.313 7.313 0 1.722-.563 3.304-1.582 4.535l4.71 4.71zM1.687 7.562a5.597 5.597 0 005.625 5.625 5.619 5.619 0 005.625-5.624c0-3.094-2.53-5.625-5.624-5.625a5.619 5.619 0 00-5.625 5.625z"
  })));
}
export default SvgSearchIcon;